import clsx from 'clsx/lite';
import { EmptyState } from 'components';
import { type FC, type JSX } from 'react';
import styles from './Field.module.css';

export interface FieldProps {
  className?: string;
  label: string;
  value?: React.ReactNode;
  hidden?: boolean;
  animated?: boolean;
  direction?: 'column' | 'row';
  labelClassName?: string;
  valueClassname?: string;
  emptyStateText?: string;
  labelId?: string;
}

type JSXDiv = JSX.IntrinsicElements['div'];
type AllFieldProps = FieldProps & Pick<JSXDiv, Exclude<keyof JSXDiv, keyof FieldProps>>;

const Field: FC<AllFieldProps> = ({
  label,
  value,
  className,
  hidden = false,
  animated = false,
  direction = 'row',
  labelClassName,
  valueClassname,
  emptyStateText,
  labelId,
  ...rest
}) => (
  <div
    className={clsx(
      className,
      styles.wrapper,
      hidden && styles.hidden,
      animated && styles.animated,
      direction === 'column' && styles.columnDirection
    )}
    {...rest}
  >
    <span className={clsx(styles.label, labelClassName)} id={labelId}>
      {label}
    </span>
    <span className={clsx(styles.value, !value && styles.noValue, valueClassname)}>
      {value || <EmptyState text={emptyStateText} />}
    </span>
  </div>
);

export default Field;
